import React, { useState, useEffect } from 'react';
import './index.less';
import $i18n from '@/i18n';
import Requests from '@/services/request';
import { Icon, Timeline, Tag, Modal, Input, Form, Table, Message } from '@b-design/fusion';
import { formatTime } from '@/utils';
import { getQueryStringArgs } from '@/utils/url-parse';
import QRCode from '@/components/QRCode'
import Button, { promisifyValidate } from '@/components/Button';
import { Field } from '@alifd/next';
import NameIcon from '@/components/NameIcon';
import Confirm from '@/components/Confirm';
import DefaultAppIcon from '@/components/DefaultAppIcon';
import CalculateComponent from '@/components/CalculateComponent';
import { tableColumons } from './config'



interface App {
  approvalDetail: any;
  initDataSource: any;
  roleList: string[];
}

interface IRecord {
  id: string;
  jsapiName: string;
  functionDesc: string;
  channelName: string;
  supportSystem: string[];
  controlStatus: "CONTROLLED" | "UNCONTROLLED"

}

interface IDataSource {
  list: IRecord[],
  total: number
}




const JsapiAuth: React.FC<App> = ({ approvalDetail, initDataSource, roleList }) => {
  const [contentHeight, setContentHeight] = useState(200);
  const field = Field.useField();
  const { init, getValue, setValue, getError } = field;
  const { approveId } = getQueryStringArgs();
  const [isRejectModalVisible, setIsRejectModalVisible] = useState(false);
  const [dataSource, setDataSource] = useState<IDataSource>({ list: [], total: 0 });
  const [loading, setLoading] = useState(false);
  const [expand, setExpand] = useState(false)
  const renderPhone = (v) => {
    let text = '';
    if (v !== '-') {
      if (v?.split('-')[0]) {
        text = `+${v?.split('-')[0]} ${v?.split('-')[1]}`;
      } else {
        text = `${v?.split('-')[1]}`;
      }
    } else {
      text = '';
    }
    return text;
  };

  useEffect(() => {
    const list = approvalDetail?.extInfo?.applyJsapiList || []
    const newList = list?.map((item) => {
      return {
        ...item,
        id: `${item.jsapiName}_${item.channelCode}`
      }
    })
    setDataSource({
      list: newList,
      total: newList.length,
    })
  }, [approvalDetail])

  // 通过按钮
  const handleOk = async () => {
    const data = await Requests.post('/rest/intercnn/approve/process', {
      approveId,
      approveAction: 'PASSED',
      approveOpinion: 'PASSED',
    });
    if (data) {
      initDataSource();
    }
  };
  // 拒绝按钮
  const handleRejectOk = async () => {
    const [errs, vals] = await promisifyValidate(field);
    if (errs) {
      return;
    }

    const data = await Requests.post('/rest/intercnn/approve/process', {
      approveId,
      approveAction: 'REJECT',
      approveOpinion: getValue('description'),
    });
    if (data) {
      setIsRejectModalVisible(false);
      initDataSource();
    }
  };

  const onExpand = () => {
    setExpand(state => !state)
  }

  return (
    <>
      <div className="jsapi-approvals-details-table-container">
        <div className='table-header-title'>
          {
            $i18n.get({
              id: 'aopf.pages.miniapp.version.info.process.Approvals.applyInfo',
              dm: '申请信息',
            })
          }
        </div>
        <div style={{ position: 'relative', ["--table-body-height"]: `${expand ? 400 : 74}px`, transition: 'all .3s' }}>
          <div style={{ marginBottom: dataSource.list.length >= 2 ? 34 : 16 }}>
            <Table.StickyLock
              className="jsapi-auth-table"
              primaryKey="jsapiName"
              columns={tableColumons}
              dataSource={dataSource?.list}
              fixedHeader
              hasBorder={false}
              maxBodyHeight={`var(--table-body-height, 34px)`}
              loading={loading}
            />
          </div>
          {
            dataSource.list.length >= 2 && <div style={{ cursor: 'pointer', position: 'absolute', bottom: -30, width: '100%', height: 36, background: '#ffffff', display: 'flex', justifyContent: 'center', alignItems: 'center', boxShadow: expand ? "inset 0 1px 0 0 #F2F3F7" : "0px -20px 18px 0px rgba(255,255,255,0.6)" }}
              onClick={() => onExpand()}
            >
              {
                expand ? $i18n.get({
                  id: 'aopf.pages.approvals.detail.applyTable.collapse',
                  dm: '收起全部',
                }) : $i18n.get({
                  id: 'aopf.pages.approvals.detail.applyTable.expand',
                  dm: '展开全部',
                })
              } <span style={{ height: 10, width: 10, marginLeft: 10, display: 'inline-flex', justifyContent: '60% 60%', alignItems: 'center', transition: 'all 0.3', transformOrigin: 'center', transform: expand ? 'rotateZ(180deg)' : 'rotateZ(0deg)' }}><span style={{ display: 'inline-block', width: 8, height: 8, borderBottom: '2px solid #585F7E', borderRight: '2px solid #585F7E', transform: ' scale(0.8) rotateZ(45deg)' }}></span></span>
            </div>
          }
        </div>

      </div>
      <div className="approvals-container">
        <div className="container-left">
          <div className="container-processTitle">
            {$i18n.get({
              id: 'aopf.pages.miniapp.version.info.process.Approvals.Process',
              dm: '审批流程',
            })}
          </div>
          <Timeline>
            <Timeline.Item
              title={
                <div className="progress-item">
                  <span>{approvalDetail?.createName}</span>
                  <span>{formatTime(approvalDetail?.gmtCreate)}</span>
                </div>
              }
              content={
                <div className="progress-content">
                  <div className="progress-dec">
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.process.Submit.JsapiAuth.Application',
                      dm: '提交申请 JSAPI 授权',
                    })}
                  </div>
                  <Tag data-square>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.process.Application',
                      dm: '申请',
                    })}
                  </Tag>
                  <span className="progress-content-text">
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.process.JsapiAuth.Information',
                      dm: '申请 JSAPI 授权',
                    })}
                  </span>
                </div>
              }
            />
            {approvalDetail?.status !== 'PROCESSING' ? (
              <Timeline.Item
                title={
                  <div className="progress-item">
                    <span>{approvalDetail?.modifiedName}</span>
                    <span>{formatTime(approvalDetail?.gmtModified)}</span>
                  </div>
                }
                content={
                  <div className="progress-content">
                    {approvalDetail?.approveAction === 'PASSED' ? (
                      <div>
                        <div className="progress-dec">
                          {$i18n.get({
                            id: 'aopf.pages.miniapp.version.info.process.Review.JsapiAuth.Application',
                            dm: '审查 JSAPI 授权申请',
                          })}
                        </div>
                        <Tag data-square data-tag-color="cold-green">
                          {$i18n.get({
                            id: 'aopf.pages.miniapp.version.info.process.Passed',
                            dm: '审批通过',
                          })}
                        </Tag>
                      </div>
                    ) : approvalDetail?.approveAction === 'WITHDRAW' ? (
                      <>
                        <div className="progress-dec">
                          {$i18n.get({
                            id: 'aopf.pages.miniapp.version.info.process.Review.jsapiAuth.WithDraw',
                            dm: '撤销授权',
                          })}
                        </div>
                        <Tag data-square color="#FFF4ED" style={{ color: '#FF7E33' }}>
                          {$i18n.get({
                            id: 'aopf.pages.miniapp.version.info.process.Withdraw',
                            dm: '撤销',
                          })}
                        </Tag>
                      </>
                    ) : (
                      <>
                        <div className="progress-dec">
                          {$i18n.get({
                            id: 'aopf.pages.miniapp.version.info.process.Review.JsapiAuth.Application',
                            dm: '审查 JSAPI 授权申请',
                          })}
                        </div>
                        <Tag data-square data-tag-color="red">
                          {$i18n.get({
                            id: 'aopf.pages.miniapp.version.info.process.Refused',
                            dm: '拒绝',
                          })}
                        </Tag>
                        <span className="progress-content-text">
                          {approvalDetail?.approveOpinion
                            ? approvalDetail?.approveOpinion
                            : $i18n.get({
                              id: 'aopf.pages.miniapp.version.info.process.No.Reason',
                              dm: '拒绝',
                            })}
                        </span>
                      </>
                    )}
                  </div>
                }
              />
            ) : (
              <></>
            )}
          </Timeline>
          {approvalDetail?.status === 'PROCESSING' && roleList.includes('ADMIN') && (
            <div className="progress-withdraw">
              <Confirm
                trigger={
                  <Button type="primary" style={{ marginRight: '16px' }}>
                    {$i18n.get({
                      id: 'aopf.approvals.datail.approve',
                      dm: '批准',
                    })}
                  </Button>
                }
                dialogTitle={$i18n.get({
                  id: 'aopf.pages.approvals.version.info.process.approved',
                  dm: '审批详情',
                })}
                dialogContent={$i18n.get({
                  id: 'aopf.pages.approvals.detail.agreeContent.jsapiAuthPass',
                  dm: '你正在处理 JSAPI 授权申请,是否批准',
                })}
                onClick={handleOk}
              />
              <Button type="secondary" onClick={() => setIsRejectModalVisible(true)}>
                {$i18n.get({
                  id: 'aopf.approvals.datail.reject',
                  dm: '拒绝',
                })}
              </Button>
            </div>
          )}
        </div>

        <div className="container-right" style={{ position: 'relative' }}>
          {approvalDetail?.extInfo?.description?.iconPublicUrl ? (
            <img className="logo" src={approvalDetail?.extInfo?.description?.iconPublicUrl} />
          ) : (
            <DefaultAppIcon className="logo" />
          )}
          <div className="right-appInfo">
            {$i18n.get({
              id: 'aopf.pages.miniapp.version.info.App.information',
              dm: '应用程序信息',
            })}
          </div>
          <div className="right-content">
            <div className="right-icon">
              <Icon type="mobile--outline" size="xs" />
            </div>
            <div className="right-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.Miniapp.Name',
                dm: 'Miniapp名称',
              })}
            </div>
            <div className="left-context">{approvalDetail?.extInfo?.description?.name}</div>
          </div>

          <div className="right-content">
            <div className="right-icon">
              <Icon type="apps--outline" size="xs" />
            </div>
            <div className="right-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.Type',
                dm: '类型',
              })}
            </div>
            <div className="left-context">{approvalDetail?.extInfo?.app?.framework}</div>
          </div>

          <div className="right-content">
            <div className="right-icon">
              <Icon type="user--outline" size="xs" />
            </div>
            <div className="right-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.process.Creator',
                dm: '作者',
              })}
            </div>
            <div className="left-context">{approvalDetail?.extInfo?.description?.createName}</div>
          </div>

          <div className="right-content">
            <div className="right-icon">
              <Icon type="wikis--outline" size="xs" />
            </div>
            <div className="right-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.Slogan',
                dm: '标语',
              })}
            </div>
            <div className="left-context">{approvalDetail?.extInfo?.description?.slogan}</div>
          </div>

          <div className="right-content">
            <div className="right-icon">
              <Icon type="document--outline" size="xs" />
            </div>
            <div className="right-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.Description',
                dm: '描述',
              })}
            </div>
            <div className="left-context">{approvalDetail?.extInfo?.description?.description}</div>
          </div>
        </div>
        <Modal
          title={$i18n.get({
            id: 'aopf.pages.approvals.version.info.process.reject',
            dm: '拒绝申请',
          })}
          // data-size="xs"
          visible={isRejectModalVisible}
          // onOk={handleRejectOk}
          onCancel={() => setIsRejectModalVisible(false)}
          closeMode={['close', 'esc', 'mask']}
          onClose={() => setIsRejectModalVisible(false)}
          footer={
            <div>
              <Button onClick={() => setIsRejectModalVisible(false)}>
                {$i18n.get({
                  id: 'aopf.pages.approvals.version.info.confirm.Cancel',
                  dm: '取消',
                })}
              </Button>
              <Button type="primary" onClick={handleRejectOk} style={{ marginLeft: '8px' }}>
                {$i18n.get({
                  id: 'aopf.pages.approvals.version.info.confirm.Ok',
                  dm: '确定',
                })}
              </Button>
            </div>
          }
        >
          <div
            style={{
              marginTop: '20px',
              width: '500px',
              fontSize: '14px',
              letterSpacing: '0.47px',
              lineHeight: '20px',
              fontWeight: '400',
            }}
          >
            <Form>
              <Form.Item
                name="description"
                label={$i18n.get({ id: 'aopf.pages.approvals.form.title.description', dm: '描述' })}
              >
                <Input.TextArea
                  placeholder={$i18n.get({
                    id: 'aopf.pages.approvals.form.Description.placeholder',
                    dm: '输入2-200个字符的描述',
                  })}
                  autoHeight={{ minRows: 4, maxRows: 8 }}
                  style={{ width: '470px' }}
                  {...init('description', {
                    initValue: '',
                    rules: {
                      required: true,
                      minLength: 2,
                      maxLength: 200,
                      message: $i18n.get({
                        id: 'aopf.pages.approvals.form.Description.placeholder',
                        dm: '输入2-200个字符的描述',
                      }),
                    },
                  })}
                  showLimitHint
                  maxLength={200}
                />
                <p style={{ fontSize: 12, color: '#c82727' }}>{getError('description')}</p>
              </Form.Item>
            </Form>
          </div>
        </Modal>
      </div>
      <CalculateComponent
        otherWidth={280}
        otherHeight={0}
        windowChange={(_width, height) => {
          setContentHeight(height);
        }}
      />

    </>
  );
};
export default JsapiAuth;
